export default __webpack_public_path__ + "img/1_14-299bf1ad.png";